module.exports = __webpack_public_path__ + "static/media/alex-siale-qH36EgNjPJY-unsplash.df79ddf7.jpg";